import Request from "./request";

const Cms = "/cms";
const CmsPost = "/cms/posts";

export default {
  /**
   * 文章列表
   *  @param {*} type 类别
   */
  async getCms(type, query) {
    return Request.get(`${Cms}/${type}`, {
      pageSize: query.pageSize,
      current: query.current
    });
  },
  async getCmsDeatil(Id) {
    // return Request.get(CmsPost.replace(':id', Id)
    // );
    return Request.get(`${CmsPost}/${Id}`);
  }
};
